/* eslint no-restricted-globals: 0 */
/**
 * Own your Platform project.
 *
 *   - Explicit and contained DOM interface use
 *   - eslint no-restricted-globals configuration
 *   - Multi-platforms adapter library readiness
 */
export const documentGetTitle = (): string => document.title;

export const documentSetTitle = (title: string) => {
  document.title = title;
};
